import Highcharts from 'highcharts';
import type { Language } from './translations';

/**
 * Réglages globaux Highcharts selon la langue : noms de mois et de jours des axes temporels,
 * séparateurs décimaux et de milliers, libellés des boutons. Appliqué à chaque changement de langue ;
 * les graphiques se redessinent car leurs composants sont re-rendus avec les textes traduits.
 */
const LANG: Partial<Record<Language, Highcharts.LangOptions>> = {
  fr: {
    locale: 'fr-FR',
    months: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
    shortMonths: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
    weekdays: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    shortWeekdays: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
    decimalPoint: ',',
    thousandsSep: ' ',
    loading: 'Chargement…',
    noData: 'Aucune donnée à afficher',
    resetZoom: 'Réinitialiser le zoom',
    resetZoomTitle: 'Revenir au zoom 1:1',
  },
  en: {
    locale: 'en-GB',
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortWeekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    decimalPoint: '.',
    thousandsSep: ',',
    loading: 'Loading…',
    noData: 'No data to display',
    resetZoom: 'Reset zoom',
    resetZoomTitle: 'Reset zoom level 1:1',
  },
  hi: {
    locale: 'hi-IN',
    months: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर'],
    shortMonths: ['जन॰', 'फ़र॰', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल॰', 'अग॰', 'सित॰', 'अक्तू॰', 'नव॰', 'दिस॰'],
    weekdays: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार'],
    shortWeekdays: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
    decimalPoint: '.',
    thousandsSep: ',',
    loading: 'लोड हो रहा है…',
    noData: 'दिखाने के लिए कोई डेटा नहीं',
    resetZoom: 'ज़ूम रीसेट करें',
    resetZoomTitle: 'ज़ूम 1:1 पर रीसेट करें',
  },
};

export function applyChartLanguage(language: Language): void {
  Highcharts.setOptions({ lang: LANG[language] ?? LANG.en });
}
